import { cva, type VariantProps } from "class-variance-authority";

export const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-sm text-sm font-medium ring-offset-background transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default:
          "bg-primary text-primary-foreground hover:bg-primary/90 shadow-sm hover:shadow-md",
        destructive:
          "bg-destructive text-destructive-foreground hover:bg-destructive/90 shadow-sm",
        outline: "border border-input bg-background hover:bg-muted",
        secondary:
          "bg-secondary text-secondary-foreground hover:bg-secondary/80 shadow-sm",
        ghost: "hover:bg-muted",
        link: "text-primary underline-offset-4 hover:underline",
        gradient:
          "bg-gradient-to-r from-primary to-secondary text-primary-foreground hover:opacity-90 shadow-md hover:shadow-lg",
        glass:
          "bg-white/10 backdrop-blur-sm border border-white/20 text-foreground hover:bg-white/20",
        /**
         * A labelled AI action (Fråga CAIRE): ink text on a solid card
         * surface with a restrained aurora edge. The aurora gradient itself
         * belongs to `AuroraMark`, never to the surface (design system,
         * "Colour roles" 2). Use it through `AiActionButton`.
         */
        ai: "border border-[hsl(var(--brand-aurora-blue)/0.4)] bg-card font-semibold text-foreground shadow-[0_2px_8px_hsl(var(--brand-aurora-blue)/0.14)] hover:border-[hsl(var(--brand-aurora-blue)/0.65)] hover:bg-muted",
      },
      size: {
        default: "h-10 px-4 py-2",
        sm: "h-9 rounded-sm px-3",
        lg: "h-12 rounded-sm px-8",
        xl: "h-14 rounded-sm px-10 text-base",
        icon: "h-10 w-10",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  },
);

export type ButtonVariantProps = VariantProps<typeof buttonVariants>;
